import config from 'appConfig';

export const makePrice = (
  amount,
  locale = config.locale,
  currency = config.currency,
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);
};

export const slugify = (text) => {
  return text
    .toString()
    .normalize('NFD') // Normalize diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-');
};

export const isTruthy = (value) =>
  typeof value === 'string'
    ? value.toLowerCase() === 'true' || value === '1'
    : Boolean(value);
